export default "__VITE_ASSET__Bsb$M$Me__"